/* eslint-disable camelcase */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import Modal from '../Modal/Modal'
import Text from '../Text/Text'
import Flex from '../Flex/Flex'
import Tag from '../Tag/Tag'
import Button from '../Button/Button'
import LoadingBounce from '../LoadingBounce/LoadingBounce'

const ModalMatriz = ({
  visible,
  clientWalletCode,
  initialValues,
  onConfirm
}) => {
  const priorityMatrices = useSelector(
    (state) => state.timelineReducer.priorityMatrices
  )

  const [list, setList] = useState([])
  const [selecteds, setSelecteds] = useState(initialValues)
  const dispatch = useDispatch()

  const { fetching, content } = priorityMatrices

  useEffect(() => {
    if (visible && clientWalletCode) {
      dispatch(
        reducks.resources.timeline.actions.getPriorityMatricesByStore(
          clientWalletCode
        )
      )
    }
  }, [visible, clientWalletCode])

  const onSubmit = () => {
    dispatch(reducks.resources.timeline.actions.clearPriorityMatricesByStore())
    onConfirm(selecteds)
  }

  useEffect(() => {
    if (content) {
      setList(content)
    }
  }, [content])

  const handleSelect = (name) => {
    if (!selecteds.find((item) => item === name)) {
      const newlist = list.flatMap((listItem) => {
        if (listItem.name === name) {
          return {
            ...listItem,
            active: true
          }
        }
        return listItem
      })

      setList(newlist)
      setSelecteds([...selecteds, name])
    } else {
      const newselecteds = selecteds.filter((item) => item !== name)
      setSelecteds(newselecteds)

      const newlist = list.flatMap((listItem) => {
        if (listItem.name === name) {
          return {
            ...listItem,
            active: false
          }
        }

        return listItem
      })
      setList(newlist)
    }
  }

  return (
    <Modal
      visible={visible}
      size="small"
      rounded
      HeaderContent={() => (
        <>
          <Text
            value="Matriz de Prioridades"
            size="md"
            color="gray"
            variation="dark"
            bold
          />
        </>
      )}
    >
      <Flex wrap="wrap" margin="10px 0px">
        {list.map((tag) => (
          <Tag
            onClick={() => handleSelect(tag.name)}
            key={tag.id}
            id={tag.id}
            active={tag.active}
            text={tag.name}
            size="xxs"
          />
        ))}
        {fetching && (
          <Flex justifyContent="center" width="100%" padding="32px 0">
            <LoadingBounce />
          </Flex>
        )}
      </Flex>

      <Flex alignItems="center" justifyContent="center" margin="10px 0px">
        <Button type="secondary" onClick={onSubmit}>
          Selecionar marcados
        </Button>
      </Flex>
    </Modal>
  )
}

ModalMatriz.defaultProps = {
  visible: false,
  initialValues: []
}

ModalMatriz.propTypes = {
  visible: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  clientWalletCode: PropTypes.string.isRequired,
  initialValues: PropTypes.arrayOf(PropTypes.string)
}

export default ModalMatriz
